const jobs = (axios) => {
  return {

    /**
         * @param params
         * @method get
         * @api /api/job/get_all?page=${params.page}&ppage=${params.perPage}
         */
    get (params) {
      return axios.get(`/job/get_all/?page=${params.page}&ppage=${params.perPage}`)
        .then((response) => response);
    },

    /**
         * @param params
         * @method post
         * @api /api/accept_job
         */
    accept (params) {
      return axios.post('/accept_job', params)
        .then((response) => response);
    },

    /**
         * @param params
         * @method get
         * @api /api/job_history/get
         */
    getHistory (params) {
      return axios.get('/job_history/get', {
        params: params,
      })
        .then((response) => response);
    },

    /**
         * @param id
         * @method get
         * @api /api/reports/get_in_task
         */
    getReportByTaskID (id) {
      return axios.get(`/reports/get_in_task/${id}`)
        .then((response) => response);
    },

    /**
         * @param id
         * @method get
         * @api /api/jobs/{id}
         */
    jobsDetail (id) {
      return axios.get(`/jobs/${id}`)
        .then((response) => response);
    },

    /**
         * @param id
         * @method get
         * @api /api/job/get_task/{id}
         */
    getTaskInJobDetail (id) {
      return axios.get(`/job/get_task/${id}`)
        .then((response) => response);
    },

    /**
         * @param id
         * @method get
         * @api /api/job/get_job_attachment/{id}
         */
    getAttachment (id) {
      return axios.get(`/job/get_job_attachment/${id}`)
        .then((response) => response);
    },

    /**
         * @param file
         * @method get
         * @api /api/{url file}
         */
    getFiles (file) {
      return axios.get(`${file}`)
        .then((response) => response);
    },

    /**
         * @param path
         * @method post
         * @api /api/job/set_att_as_deleted/{path file}
         */
    removeFiles (path) {
      return axios.post(`/job/set_att_as_deleted/${path}`)
        .then((response) => response);
    },

    /**
         * @param params
         * @method post
         * @api /api/job/update/
         */
    updateJob (params) {
      return axios.post('/job/update/', params)
        .then((response) => response);
    },

    /**
         * @param fileForm
         * @method post
         * @api /api/job/upload_attachment/
         */
    uploadAttachments (id, fileForm) {
      return axios.post(`/job/upload_attachment/${id}`, fileForm, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => response);
    },

    /**
         * @method get
         * @api /api/jobs/getTypes
         */
    getJobTypes () {
      return axios.get('/jobs/getTypes')
        .then((response) => response);
    },

    /**
         * @param params
         * @method get
         * @api /api/jobs/similar_langs
         */
    getJobLanguages (params) {
      return axios.get('/jobs/similar_langs', {
        params: params,
      })
        .then((response) => response);
    },

    /**
         * @param params
         * @method post
         * @api /api/jobs/setExecutors
         */
    setExecutors (params) {
      return axios.post('/job/setExecutors/', params)
        .then((response) => response);
    },

    /**
         * @param id
         * @method post
         * @api /api/jobs/close
         */
    closeJob (id) {
      return axios.post(`/job/close/${id}`)
        .then((response) => response);
    },

    /**
         * @param params
         * @method post
         * @api /api/report/add
         */
    addReportTojob (params) {
      return axios.post('/report/add', params.params, {
        headers: {
          'Content-Type': 'text/xml',
          'JobId': params.id,
          'JobComment': params.comment,
        },
      })
        .then((response) => response);
    },

    /**
         * @param params
         * @method post
         * @api /api/job/add_new_comment
         */
    addCommentReportToJob (params) {
      return axios.post('/job/add_new_comment', params)
        .then((response) => response);
    },

    /**
         * @param params
         * @method post
         * @api /api/response
         */
    rejectJob (id) {
      return axios.post(`/reject_job/${id}`)
        .then((response) => response);
    },

    comments: {

      /**
             * @param params
             * @method get
             * @api /api/job/get_all_comments
             */
      getComments (params) {
        return axios.get('/job/get_all_comments', {
          params: params,
        })
          .then((response) => response);
      },

      /**
             * @param params
             * @method post
             * @api /api/job/add_new_comment
             */
      addComment (params) {
        return axios.post('/job/add_new_comment', params)
          .then((response) => response);
      },

      /**
             * @param params
             * @method post
             * @api /api/job/edit_comment
             */
      editComment (params) {
        return axios.post('/job/edit_comment', params)
          .then((response) => response);
      },

      /**
             * @param params
             * @method post
             * @api /api/job/remove_comment
             */
      removeComment (id) {
        return axios.post(`/job/remove_comment/${id}`)
          .then((response) => response);
      },

    },
  };
};

export default jobs;
